<template>
    <v-display :form="form" :path="path" :label="label" value="" hide-underline>
        <q-btn-group class="no-shadow v-radio-button q-mt-xs" outline rounded>
            <q-btn v-for="option in options"
                   :key="option.value"
                   :icon="option.icon"
                   :label="option.label"
                   :outline="inputValue != option.value"
                   :color="inputValue == option.value ? (option.color ? option.color : color) : 'faded'"
                   :disable="form.busy || disable"
                   @click="inputValue = option.value; onInput()"
                   no-caps rounded class="no-shadow"/>
        </q-btn-group>
    </v-display>
</template>

<script>
    import mixins from './mixins'
    import {
        QBtnGroup,
        QBtn
    } from 'quasar-framework'

    export default {
        name: 'VRadioButtons',

        mixins,

        props: {
            options: {
                type: Array,
                required: true
            }
        },

        components: {
            QBtnGroup,
            QBtn
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VRadioButtons.vue